// Remembers the email of the last Google account that successfully signed
// in on *this* origin, so a later sign-in attempt (same browser, same
// origin) can pass it to Google as a `login_hint` - this does NOT share a
// session across thunderstone.aroundtableround.com and
// spacebase.aroundtableround.com (that's a separate, much bigger problem -
// see CLAUDE.md's Site Access section and the cross-domain-auth
// investigation referenced there); it only means that *within one app*,
// clicking "Sign in with Google" again goes straight to (or pre-selects)
// the right account instead of showing a blank chooser, which matters most
// on a device signed into more than one Google account. Same pattern as
// localGameStorage.js: best-effort, never worth breaking sign-in over.
const STORAGE_KEY = 'aroundtableround:lastSignInEmail:v1';

function safeLocalStorage() {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function readLastSignInEmail() {
  const storage = safeLocalStorage();
  if (!storage) return null;
  try {
    return storage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function writeLastSignInEmail(email) {
  const storage = safeLocalStorage();
  if (!storage || !email) return;
  try {
    storage.setItem(STORAGE_KEY, email);
  } catch {
    // best-effort only - see comment above
  }
}
